<template>
  <div class="home">
  
    <Reproductor msg="Lección #2" audio2="../mp3/SecundariaA/02SA.mp3" cover="../img/8.jpg" name="Secundaria A"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA2',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
